import "./Missions.module.css";
import Header from "@/reusable_sections/Header";
import Missions from "./sections/Missions";
import Missionsbanner from "./sections/Missionsbanner";
import Misionesusafeature from "./sections/Misionesusafeature";
import Initiatives from "./sections/Initiatives";
import Ministryinitiatives from "./sections/Ministryinitiatives";
import Footer from "@/reusable_sections/Footer";
export default function MissionsPage() {
  return <div>
      <Header />
      <Missions />
      <Missionsbanner />
      <Misionesusafeature />
      <Initiatives />
      <Ministryinitiatives />
      <Footer />
    </div>;
}